import React from "react"
import { StyledSquareCard, SquareBody } from "./styled"

const SquareCard = () => <StyledSquareCard />

SquareCard.Body = SquareBody

export default SquareCard
